// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_link__fbzg2 {
    --width: 226px;
    --height: 200px;

    --offset-top: 6px;
    --offset-left: -8px;

    position: relative;
    width: var(--width);
    /*height: var(--height);*/
    display: flex;
    margin: 0;
    transition:
        margin-left 0.1s,
        margin-right 0.1s;
}

.styles_link__fbzg2:first-child {
    z-index: 10;
}

.styles_link__fbzg2.styles_closed__Ko8Tp:nth-child(2) {
    z-index: 9;
    margin-left: var(--offset-left);
    margin-top: calc((var(--height) + var(--offset-top)) * -1);
}

.styles_link__fbzg2.styles_closed__Ko8Tp:nth-child(3) {
    z-index: 8;
    margin-left: calc(var(--offset-left) * 2);
    margin-top: calc((var(--height) + var(--offset-top) * 2) * -1);
}

.styles_link__fbzg2.styles_closed__Ko8Tp:nth-child(3) ~ .styles_link__fbzg2 {
    z-index: 7;
    margin-left: calc(var(--offset-left) * 3);
    margin-top: calc((var(--height) + var(--offset-top) * 3) * -1);
}

.styles_content__\\+077D {
    --width: 226px;
    --height: 200px;

    position: relative;

    flex: 1 1;
    /*display: flex;*/
    /*flex-direction: column;*/

    /*display: grid;*/
    /*grid-row: span 5;*/
    /*grid-template-rows: subgrid;*/

    cursor: pointer;
}

.styles_choice__guLhi {
    transition: color 0.1s;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 6px;
}

.styles_link__fbzg2.styles_closed__Ko8Tp:not(:first-child) .styles_choice__guLhi {
    opacity: 0;
}

.styles_link__fbzg2.styles_open__aj0pN .styles_groupId__L9fjT {
    opacity: 0;
}

.styles_imgWrapper__YSNaW {
    /*border: 1px solid #7b848e;*/
    /*background: #fbfbfb;*/
    position: relative;
    /*height: var(--height);*/
    color: var(--primary-color);
}

.styles_imgWrapperContent__DFHuN {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: inherit;
    width: inherit;
    color: var(--primary-color);
}

.styles_imgWrapperContent__DFHuN {
}

.styles_stack__Zyc9V {
    min-height: var(--height);
    min-width: var(--width);
    /*position: absolute;*/
    top: 0;
    left: 0;
    /*border: 1px solid #7b848e;*/
    /*background: #fbfbfb;*/

    display: grid;
    grid-template-columns: 1fr;
    /* Ensure the container is tall enough for the stack */
    /*padding-top: var(--height);*/
    justify-content: center;
    margin-bottom: 16px;

    --total: 0;
    --i: 0;

    padding-right: calc(var(--total, 0) * 6px);
}

.styles_stackItem__jSRo8 {
    grid-area: 1 / 1; /* All boxes occupy the same grid space */

    /* Use the variable --i to offset each card downwards */
    /* If --i is 1, it moves 0px. If --i is 2, it moves 20px, etc. */
    /*transform: translateX(calc((var(--i)) * 6px));*/
    margin-top: calc((var(--i)) * 6px);
    margin-left: calc((var(--i)) * 6px);
    /*padding-right: calc((var(--i)) * 6px);*/
    /* Ensure the last box (highest --i) is on top */
    /*z-index: var(--i);*/

    /* Card Styling */
    /*display: flex;*/
    /*justify-content: center;*/
    max-width: 100%;
    min-width: 100%;
}

.styles_stackItemInner__OH1QA,
.styles_imgWrapperContent__DFHuN {
    border: 1px solid #7b848e;
    background: #fbfbfb;
    height: var(--height);
    min-height: var(--height, 150px);
    width: var(--width, 180px);
    max-width: var(--width, 180px);

    margin: auto;
}

.styles_imgWrapperContent__DFHuN {
    position: relative;
}

.styles_groupId__L9fjT {
    color: var(--secondary-color);
    position: absolute;
    top: 8px;
    left: 8px;
    transition: opacity 0.1s;
}

.styles_imgWrapper__YSNaW img {
    width: 50%;
}

.styles_content__\\+077D p {
    font-size: 13px;
    /*font-weight: 300;*/
    display: grid;
    grid-template-columns: 120px 1fr;
    margin: 2px 0;
    grid-gap: 6px;
    /*line-break: anywhere;*/
}

.styles_selecting__dzf87 a {
    pointer-events: none;
}

.styles_selecting__dzf87 .styles_stackItemInner__OH1QA,
.styles_selecting__dzf87 .styles_imgWrapperContent__DFHuN {
    background: var(--light-grey);
}

.styles_selecting__dzf87.styles_selected__KPyMD .styles_stackItemInner__OH1QA,
.styles_selecting__dzf87.styles_selected__KPyMD .styles_imgWrapperContent__DFHuN {
    background: #f0f3f7;
}

.styles_selectedCheck__ijyUd {
    --img-size: 34px;

    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
}
.styles_selectedCheck__ijyUd img {
    width: var(--img-size);
}

/*.selectedCheck {*/
/*    display: none;*/
/*}*/

/*.selecting.selected.link:first-child .selectedCheck,*/
/*.selecting.selected.link.open .selectedCheck {*/
/*    display: block;*/
/*}*/

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_link__fbzg2,
    .styles_content__\\+077D {
        --width: 180px;
        --height: 150px;
    }

    .styles_content__\\+077D p {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TaxOptimisation/components/TaxBox/styles.module.css"],"names":[],"mappings":"AAEA;IACI,cAAc;IACd,eAAe;;IAEf,iBAAiB;IACjB,mBAAmB;;IAEnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,SAAS;IACT;;yBAEqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,+BAA+B;IAC/B,0DAA0D;AAC9D;;AAEA;IACI,UAAU;IACV,yCAAyC;IACzC,8DAA8D;AAClE;;AAEA;IACI,UAAU;IACV,yCAAyC;IACzC,8DAA8D;AAClE;;AAEA;IACI,cAAc;IACd,eAAe;;IAEf,kBAAkB;;IAElB,SAAO;IACP,iBAAiB;IACjB,0BAA0B;;IAE1B,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;;IAE/B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;AACA;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,MAAM;IACN,OAAO;IACP,6BAA6B;IAC7B,uBAAuB;;IAEvB,aAAa;IACb,0BAA0B;IAC1B,sDAAsD;IACtD,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;;IAEnB,UAAU;IACV,MAAM;;IAEN,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB,EAAE,yCAAyC;;IAE3D,uDAAuD;IACvD,gEAAgE;IAChE,iDAAiD;IACjD,kCAAkC;IAClC,mCAAmC;IACnC,yCAAyC;IACzC,gDAAgD;IAChD,qBAAqB;;IAErB,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,0BAA0B;IAC1B,8BAA8B;;IAE9B,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;;IAEhB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;AACd;AACA;IACI,sBAAsB;AAC1B;;AAEA,mBAAmB;AACnB,qBAAqB;AACrB,IAAI;;AAEJ,uDAAuD;AACvD,iDAAiD;AACjD,sBAAsB;AACtB,IAAI;;AAEJ;IACI;;QAEI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@value screen-md-max from '../../../../breakpoints.css';\n\n.link {\n    --width: 226px;\n    --height: 200px;\n\n    --offset-top: 6px;\n    --offset-left: -8px;\n\n    position: relative;\n    width: var(--width);\n    /*height: var(--height);*/\n    display: flex;\n    margin: 0;\n    transition:\n        margin-left 0.1s,\n        margin-right 0.1s;\n}\n\n.link:first-child {\n    z-index: 10;\n}\n\n.link.closed:nth-child(2) {\n    z-index: 9;\n    margin-left: var(--offset-left);\n    margin-top: calc((var(--height) + var(--offset-top)) * -1);\n}\n\n.link.closed:nth-child(3) {\n    z-index: 8;\n    margin-left: calc(var(--offset-left) * 2);\n    margin-top: calc((var(--height) + var(--offset-top) * 2) * -1);\n}\n\n.link.closed:nth-child(3) ~ .link {\n    z-index: 7;\n    margin-left: calc(var(--offset-left) * 3);\n    margin-top: calc((var(--height) + var(--offset-top) * 3) * -1);\n}\n\n.content {\n    --width: 226px;\n    --height: 200px;\n\n    position: relative;\n\n    flex: 1;\n    /*display: flex;*/\n    /*flex-direction: column;*/\n\n    /*display: grid;*/\n    /*grid-row: span 5;*/\n    /*grid-template-rows: subgrid;*/\n\n    cursor: pointer;\n}\n\n.choice {\n    transition: color 0.1s;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin-top: 6px;\n}\n\n.link.closed:not(:first-child) .choice {\n    opacity: 0;\n}\n\n.link.open .groupId {\n    opacity: 0;\n}\n\n.imgWrapper {\n    /*border: 1px solid #7b848e;*/\n    /*background: #fbfbfb;*/\n    position: relative;\n    /*height: var(--height);*/\n    color: var(--primary-color);\n}\n\n.imgWrapperContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: inherit;\n    width: inherit;\n    color: var(--primary-color);\n}\n\n.imgWrapperContent {\n}\n\n.stack {\n    min-height: var(--height);\n    min-width: var(--width);\n    /*position: absolute;*/\n    top: 0;\n    left: 0;\n    /*border: 1px solid #7b848e;*/\n    /*background: #fbfbfb;*/\n\n    display: grid;\n    grid-template-columns: 1fr;\n    /* Ensure the container is tall enough for the stack */\n    /*padding-top: var(--height);*/\n    justify-content: center;\n    margin-bottom: 16px;\n\n    --total: 0;\n    --i: 0;\n\n    padding-right: calc(var(--total, 0) * 6px);\n}\n\n.stackItem {\n    grid-area: 1 / 1; /* All boxes occupy the same grid space */\n\n    /* Use the variable --i to offset each card downwards */\n    /* If --i is 1, it moves 0px. If --i is 2, it moves 20px, etc. */\n    /*transform: translateX(calc((var(--i)) * 6px));*/\n    margin-top: calc((var(--i)) * 6px);\n    margin-left: calc((var(--i)) * 6px);\n    /*padding-right: calc((var(--i)) * 6px);*/\n    /* Ensure the last box (highest --i) is on top */\n    /*z-index: var(--i);*/\n\n    /* Card Styling */\n    /*display: flex;*/\n    /*justify-content: center;*/\n    max-width: 100%;\n    min-width: 100%;\n}\n\n.stackItemInner,\n.imgWrapperContent {\n    border: 1px solid #7b848e;\n    background: #fbfbfb;\n    height: var(--height);\n    min-height: var(--height, 150px);\n    width: var(--width, 180px);\n    max-width: var(--width, 180px);\n\n    margin: auto;\n}\n\n.imgWrapperContent {\n    position: relative;\n}\n\n.groupId {\n    color: var(--secondary-color);\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    transition: opacity 0.1s;\n}\n\n.imgWrapper img {\n    width: 50%;\n}\n\n.content p {\n    font-size: 13px;\n    /*font-weight: 300;*/\n    display: grid;\n    grid-template-columns: 120px 1fr;\n    margin: 2px 0;\n    grid-gap: 6px;\n    /*line-break: anywhere;*/\n}\n\n.selecting a {\n    pointer-events: none;\n}\n\n.selecting .stackItemInner,\n.selecting .imgWrapperContent {\n    background: var(--light-grey);\n}\n\n.selecting.selected .stackItemInner,\n.selecting.selected .imgWrapperContent {\n    background: #f0f3f7;\n}\n\n.selectedCheck {\n    --img-size: 34px;\n\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n}\n.selectedCheck img {\n    width: var(--img-size);\n}\n\n/*.selectedCheck {*/\n/*    display: none;*/\n/*}*/\n\n/*.selecting.selected.link:first-child .selectedCheck,*/\n/*.selecting.selected.link.open .selectedCheck {*/\n/*    display: block;*/\n/*}*/\n\n@media screen-md-max {\n    .link,\n    .content {\n        --width: 180px;\n        --height: 150px;\n    }\n\n    .content p {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"link": `styles_link__fbzg2`,
	"closed": `styles_closed__Ko8Tp`,
	"content": `styles_content__+077D`,
	"choice": `styles_choice__guLhi`,
	"open": `styles_open__aj0pN`,
	"groupId": `styles_groupId__L9fjT`,
	"imgWrapper": `styles_imgWrapper__YSNaW`,
	"imgWrapperContent": `styles_imgWrapperContent__DFHuN`,
	"stack": `styles_stack__Zyc9V`,
	"stackItem": `styles_stackItem__jSRo8`,
	"stackItemInner": `styles_stackItemInner__OH1QA`,
	"selecting": `styles_selecting__dzf87`,
	"selected": `styles_selected__KPyMD`,
	"selectedCheck": `styles_selectedCheck__ijyUd`
};
export default ___CSS_LOADER_EXPORT___;
